export class FilterCostsPerEmployeeGroup{
    description!: string;
}